import React, { Component } from 'react';
import styles from './Loader.scss';
import logo from "./logo.gif";

class Loader extends Component {

  render() {
    return (
      <div className={styles.loadingResults}>
        <img src={logo} className={styles.appLogo} alt="logo" />
      </div>
    );
  }

}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js